import React from 'react';
import { Loader2 } from 'lucide-react';

type LoadingLockProps = {
  loading: boolean;
  children: React.ReactNode;
  className?: string;
  message?: string;
};

const LoadingLock: React.FC<LoadingLockProps> = ({
  loading,
  children,
  className = '',
  message = 'در حال بارگذاری...',
}) => {
  return (
    <div className={`profile-loading-lock ${className}`.trim()}>
      <div className={loading ? 'profile-loading-blur' : ''}>{children}</div>
      {loading ? (
        <div className="profile-loading-overlay">
          <div className="flex items-center gap-2 text-sm text-slate-700">
            <Loader2 className="h-5 w-5 animate-spin" />
            {message}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default LoadingLock;
